import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { Task } from '@/type';

import type { WorkRedistributeFormData } from '../type';
import { useDefaultRedistributionValue } from './useDefaultValue';

export const useWorkRedistributeForm = (
  task: Task,
): UseFormReturn<WorkRedistributeFormData> => {
  const { makeDefaultValue } = useDefaultRedistributionValue(task);

  const form = useForm<WorkRedistributeFormData>({
    defaultValues: makeDefaultValue(),
    mode: 'onChange',
  });

  const { watch, trigger } = form;
  // eslint-disable-next-line react-hooks/incompatible-library
  const unAssignedUserIDList = watch('unAssignedUserID');

  useEffect(() => {
    const validateAllFields = async () => {
      if (!task.userTask) return;
      await Promise.all(
        task.userTask.map((_, index) =>
          Promise.all([
            trigger(`taskAllocations.${index}.allocateRange.0` as const),
            trigger(`taskAllocations.${index}.allocateRange.1` as const),
          ]),
        ),
      );
    };

    validateAllFields();
  }, [unAssignedUserIDList, trigger, task.userTask]);

  return form;
};
